<!--  -->
<template>
  <div class="car-container">
    <div id="carStaticsChart" style="height: 100%; width: 100%"></div>
  </div>
</template>

<script>
import echarts from "echarts";
import API from "../api/index";
export default {
  data() {
    return {
      carStaticsChart: null,
      carStaticsChartOption: {},
      carData: {},
    };
  },

  components: {},

  // computed() {},

  mounted() {
    var self = this;

    self.carStaticsChart = echarts.init(
      document.getElementById("carStaticsChart")
    );
    self.queryData().then((res) => {
      self.initTypeChartOption(res);
    });
  },

  methods: {
    queryData() {
      return new Promise((resolve, reject) => {
        this.$fetch(API.queryParkingControl).then((res) => {
          if (res.success) {
            this.carData = res.returnObj;
            resolve(this.carData);
          } else {
            this.$message.error(res.msgContent);
          }
        });
      });
    },
    initTypeChartOption(cardata) {
      this.carStaticsChart = echarts.init(
        document.getElementById("carStaticsChart")
      );

      let data = [
        {
          value: cardata.idleLot,
          name: "空闲",
          label: {
            normal: { show: true, position: "inner", formatter: "{d}%" },
          },
        },
        {
          name: "占用",
          value: Number(cardata.totalLot) - Number(cardata.idleLot),
          label: {
            normal: { show: true, position: "inner", formatter: "{d}%" },
          },
        },
      ];
      this.carStaticsChartOption = {
        // title: {
        //   text: "告警类型",
        //   top: "35%",
        //   left: "48%",
        //   textAlign: "center",
        //   textStyle: {
        //     color: "#fff",
        //     fontSize: "12px",
        //   },
        // },
        graphic: [
          {
            //环形图中间添加文字
            type: "text", //通过不同top值可以设置上下显示
            left: "center", //
            top: "35%",
            style: {
              text: cardata.totalLot,
              textAlign: "center",
              fill: "#fff", //文字的颜色
              fontSize: 28,
              lineHeight: 16,
            },
          },
          {
            //环形图中间添加文字
            type: "text", //通过不同top值可以设置上下显示
            left: "center", //
            top: "47%",
            style: {
              text: "总车位数",
              textAlign: "center",
              fill: "#fff", //文字的颜色
              fontSize: 16,
              fontWeight: 400,
              lineHeight: 16,
            },
          },
        ],

        tooltip: {
          // trigger: 'item',
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },

        legend: {
          //   orient: "vertical",
          //   top: "70%",
          bottom: 0,
          textStyle: {
            color: "#fff",
            fontSize: 12,
          },
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 112,
          formatter: function (name) {
            // let data = option.series[0].data;
            let tarValue = 0;
            for (let i = 0; i < data.length; i++) {
              if (data[i].name === name) {
                tarValue = data[i].value;
              }
            }
            let arr = [name + " " + tarValue];
            return arr.join("\n");
          },
          // data: data,

          // formatter: function (name, val) {
          //   return name + "" + val;
          // },
          // selectedMode: false,
        },
        color: ["#9FC6EB", "#6169FF", "#58A55C", "rgba(243,114,44,1)"],
        series: [
          {
            name: "车位",
            type: "pie",
            radius: ["40%", "67%"],
            center: ["50%", "40%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: "20",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: data,
            roundCap: 2, //可选项为1和2，不填则采用原有拼接方式
          },
        ],
      };

      this.carStaticsChart.setOption(this.carStaticsChartOption);
    },
  },
};
</script>
<style lang='scss' scoped>
.car-container {
  height: 100%;
}
</style>